export const REPORT_MESSAGE = {
  message: 'This message is deleted',
  is_deleted: true,
  status: 'deleted',
};
